import { useMemo } from "react"

import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const useRootfileFactory = ({ fetch, siteSelected: { id: siteId } }) => useMemo(() => ({
  upload: async file => {
    const formData = new FormData()
    formData.append('file', file)

    const data = await fetch({
      method: 'post',
      url: "cms/rootfiles/upload",
      data: formData,
      params: { site: siteId },
    });

    if (!data) {
      throw Error()
    }

    return data
  },
}), [fetch, siteId])

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('cms/rootfile')
  .extendHookCollectionsFactory('cms/rootfiles')
  .extend(useRootfileFactory)
  .factory()

export {
  Provider as RootfileProvider,
  useStore as useRootfileStore,
}
